import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { Component } from "react";
import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router";
import FlexBox from "../components/layouts/Flexbox";
import Logo from "../components/Logo";
import { APP_COLORS } from "../enums/colors";
import { ROUTE_PATHS } from "../routes/paths";
import { ArrowLeftIcon } from "@phosphor-icons/react";
import { ENUM_USER_ROLE } from "../enums";
import AuthBGImage from "./AuthBGImage";

interface Props {
  user: any;
}

interface State {
  title: string;
}

class AuthLayout extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.setPageConfig = this.setPageConfig.bind(this);
    this.state = {
      title: "",
    };
  }

  setPageConfig(config) {
    this.setState({
      ...this.state,
      ...config,
    });
  }

  render() {
    const { isLoggedIn, profileId, role, isVerified } = this.props.user;
    const { title } = this.state;

    const handleGoBack = () => {
      window.history.back();
    };

    if (isLoggedIn && localStorage.getItem("token") && profileId) {
      if (role === ENUM_USER_ROLE.VENDOR && !isVerified) {
        return <Navigate to={ROUTE_PATHS.MY_PROFILE} replace />;
      }
      return <Navigate to={ROUTE_PATHS.PROJECT.LIST} replace />;
    }

    return (
      <Box bgcolor={APP_COLORS.greyLight}>
        <Grid container width={"100%"} height={"100vh"} justifyContent={"space-between"} bgcolor={APP_COLORS.white}>
          <Grid item xs={12} lg={6} component={Stack} height={"100vh"} direction={"column"} justifyContent={"center"} alignItems={"center"} width={"100%"} flex={1}>
            <FlexBox sx={{ marginTop: 10 }}>
              <Logo />
            </FlexBox>

            <Stack justifyContent={{ xs: "flex-start", lg: "center" }} height={"100%"} width={"100%"} maxWidth={643} p={{ xs: 2, sm: 3, md: 0 }}>
              <FlexBox mb={2} textAlign={"center"} justifyContent={"center"} alignItems={"center"} gap={2}>
                {title === "Forgot Password" && (
                  <Button variant="outlined" onClick={handleGoBack} sx={{ minWidth: "auto", padding: 0, height: "40px", width: "40px", border: `2px solid ${APP_COLORS.greyLight4}` }}>
                    <ArrowLeftIcon size={24} />
                  </Button>
                )}
                <Typography variant="heading1-helveticaNeue-medium">{title}</Typography>
              </FlexBox>
              <Outlet
                context={{
                  setPageConfig: this.setPageConfig,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={6} component={FlexBox} height="100vh">
            <AuthBGImage />
          </Grid>
        </Grid>
      </Box >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, null)(AuthLayout);
